// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1SRN-","modalForm":"UpgradeEpcsModal_modalForm__33Fgg","modalFooter":"UpgradeEpcsModal_modalFooter__2zXiy"};